import React from 'react';
import { Grid, Paper, Typography, Box, useTheme } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import { reportsMockData } from '../../data/reportsMockData';

export const CaseTrendChart: React.FC = () => {
  const theme = useTheme();

  return (
    <Grid item xs={12}>
      <Paper 
        sx={{ 
          p: 3,
          background: 'white', // Changed to white background
        }}
      >
        <Typography variant="h6" sx={{ mb: 3 }}>Case Trend (Last 6 Months)</Typography>
        <Box sx={{ width: '100%', height: 300 }}>
          <LineChart
            xAxis={[{ 
              data: reportsMockData.monthlyTrend.months,
              scaleType: 'point',
            }]}
            series={[{
              data: reportsMockData.monthlyTrend.data,
              label: 'New Cases',
              area: true,
              color: theme.palette.primary.main,
              showMark: true,
            }]}
            height={300}
            margin={{ left: 60, bottom: 60 }}
          />
        </Box>
      </Paper>
    </Grid>
  );
};